import React from "react";
import PropTypes from "prop-types";

import { RESERVATION_BANNER } from "@template/state/middleware/infoBanner/constants";

import ReservationMessage from "../ReservationMessage";

const InfoBannerControl = ({ bannerType }) => {
  const bannerMap = {
    [RESERVATION_BANNER]: <ReservationMessage />
  };

  const banner = bannerMap[bannerType];

  return banner ? banner : null;
};

InfoBannerControl.propTypes = {
  bannerType: PropTypes.string
};

export default InfoBannerControl;
